import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReputationTab from "./ReputationTab";
import ReputationScanner from "./ReputationScanner";
import SocialMediaSection from "./SocialMedia/SocialMediaSection";
import * as SocialMediaStatusActions from "../../store/repIQSocialMediaStatus/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import LogoContainer from "../common/LogoContainer";
import { ApplicationState } from "../../store";

const DataSources = (props: any) => {
    const dispatch = useDispatch();
    const getSocialMediaStatus = (forceReload: boolean) => dispatch(SocialMediaStatusActions.actionCreators.getUserNetworkStatus(forceReload));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        getSocialMediaStatus(true);
    });

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="title-page-data-sources" tabIndex={-1}>
                        Online Reputation
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ReputationTab selectedTab="2" />

            <div className="row" id="content">
                <div className="col-xs-12">
                    <SocialMediaSection />
                    <ReputationScanner />
                </div>
            </div>
        </React.Fragment>
    );
};
export default DataSources;
